export default [
  "Featured",
  "Selected",
  "Editorial",
  "Women",
  "Men",
  "Commercial",
  "Make Up Only",
  "Hair Only",
  "Nails Only",
  "Personalities",
  "Portraits",
  "Kids",
  "Interior",
  "Stills",
  "Flowers",
  "Beauty",
  "Green Set Design",
  "Green Installations",
  "Vases With Flowers",
  "Event Styling",
  "Indoor Green",
  "Archive",
];
